import {JsonSubTypes, JsonTypeInfo, JsonTypeInfoAs, JsonTypeInfoId} from '@outfoxx/jackson-js';
import {ChoiceFilter, FilterInterface, TextFilter} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Filter';
import {DateTimeFilter} from 'modules/spravochnik/dt-front-page-generator/src/Entity/Filter/DateTimeFilter';

@JsonTypeInfo({
    use: JsonTypeInfoId.NAME,
    include: JsonTypeInfoAs.PROPERTY
})
@JsonSubTypes({
    types: [
        {class: () => TextFilter, name: 'text'},
        {class: () => ChoiceFilter, name: 'choice'},
        {class: () => DateTimeFilter, name: 'datetime'},
    ]
})
export abstract class RefFilter implements FilterInterface {
    get id(): string {
        return '';
    }

    hasValue(): boolean {
        return false;
    }

    get label(): string {
        return '';
    }

    get value(): any {
        return undefined;
    }

    reset(): void {
    }
}
